function init() {
  const accRoot = document.querySelector('.p-service');
  if (!accRoot) return;

  const accItems = accRoot.querySelectorAll('.p-service__item');
  accItems.forEach(bindAccordion);
}

function bindAccordion(item) {
  const question = item.querySelector('.__service__ttl');
  const answer   = item.querySelector('.__service__body');
  if (!question || !answer) return;

  // 初期スタイル設定
  answer.style.height     = '0px';
  answer.style.overflow   = 'hidden';
  answer.style.transition = 'height 0.4s ease';

  // 展開完了後に高さを auto に戻す
  answer.addEventListener('transitionend', e => {
    if (e.propertyName === 'height' && item.classList.contains('is-open')) {
      answer.style.height = 'auto';
    }
  });

  // 質問エリア（.__qa__q）のクリックで開閉
  question.addEventListener('click', () => handleToggle(item, answer));
}

function handleToggle(item, answer) {
  const isOpen = item.classList.contains('is-open');

  if (isOpen) {
    // 閉じる処理
    answer.style.height = answer.scrollHeight + 'px';
    requestAnimationFrame(() => {
      answer.style.height = '0px';
    });
    item.classList.remove('is-open');
  } else {
    // 開く処理
    answer.style.height = answer.scrollHeight + 'px';
    item.classList.add('is-open');
  }
}

export default { init };
